const doc = [({"da":({"js":({"admin":({"layout_bottom_bar":({"pagination":({"of_total":"af %{total}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;